import {Injectable} from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import {Observable} from 'rxjs';
import {TokenService} from '../../../services/local/token/token.service';
import { Router } from '@angular/router';

@Injectable()
export class TokenInterceptorService implements HttpInterceptor {

  constructor(private tokenService: TokenService, private router: Router) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const authHeader = request.headers.get('Authorization');

    if(!this.router.url.toLowerCase().includes("/public/"))
    {
      if (!authHeader || (authHeader === 'Bearer' || authHeader === null)) {
        request = request.clone({
          setHeaders: {
            Authorization: `Bearer ${this.tokenService.getAccessToken()}`
          }
        });
      }
    }

    return next.handle(request);
  }
}
